import { rpx } from 'client/lib/rpx-client';
import { loggableCheckoutError } from './checkout-logic';

export type CheckoutErrorStep = 'load' | 'checkout' | 'upsell' | 'card_change';

type ReportOpts = { step: CheckoutErrorStep; priceId?: string; err: unknown };

function clip(value: unknown, max: number) {
  return typeof value === 'string' && value ? value.slice(0, max) : undefined;
}

function isServerHandledError(err: unknown) {
  if (!err || typeof err !== 'object' || err instanceof Error) {
    return false;
  }
  const e = err as { statusCode?: unknown; error?: unknown; message?: unknown; type?: unknown };
  const isBoomPayload = typeof e.statusCode === 'number' && typeof e.error === 'string';
  const isUnknownErrorPayload = e.message === 'An unknown error occurred.';
  return isBoomPayload || isUnknownErrorPayload || e.type === 'validation';
}

export function buildCheckoutErrorReport(opts: ReportOpts) {
  if (isServerHandledError(opts.err)) {
    return;
  }
  const e = loggableCheckoutError(opts.err);
  return {
    step: opts.step,
    priceId: clip(opts.priceId, 64),
    type: clip(e.type, 64),
    code: clip(e.code, 64),
    declineCode: clip(e.decline_code, 64),
    intentId: clip(e.payment_intent_id || e.setup_intent_id, 64),
    message: clip(e.message, 512) || String(opts.err).slice(0, 512),
  };
}

export function reportCheckoutError(opts: ReportOpts) {
  const report = buildCheckoutErrorReport(opts);
  if (!report) {
    return;
  }
  rpx.courseCheckout.reportClientError(report).catch(() => undefined);
}
